<template>
  <div>
    <div style="float:right;margin-right:20px;line-height: 30px;color:#777;font-size:12px">
      © 2020-2022 鲸岛科技
    </div>
  </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>